import type { Shadows } from '@mui/material/styles/shadows';

import type { ColorScheme } from './types';

export const shadows = {
  dark: [
    'none',
    '0 1px 2px 0 rgba(0, 0, 0, 0.35)',
    '0 1px 3px 0 rgba(0, 0, 0, 0.35), 0 1px 2px -1px rgba(0, 0, 0, 0.35)',
    '0 4px 6px -1px rgba(0, 0, 0, 0.35), 0 2px 4px -2px rgba(0, 0, 0, 0.35)',
    '0 10px 15px -3px rgba(0, 0, 0, 0.35), 0 4px 6px -4px rgba(0, 0, 0, 0.35)',
    '0 20px 25px -5px rgba(0, 0, 0, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',
    '0 24px 32px -10px rgba(0, 0, 0, 0.42)',
    '0 28px 36px -12px rgba(0, 0, 0, 0.46)',
    '0 32px 40px -14px rgba(0, 0, 0, 0.48)',
    '0 36px 44px -16px rgba(0, 0, 0, 0.5)',
    '0 40px 48px -18px rgba(0, 0, 0, 0.52)',
    '0 44px 52px -20px rgba(0, 0, 0, 0.54)',
    '0 48px 56px -22px rgba(0, 0, 0, 0.56)',
    '0 52px 60px -24px rgba(0, 0, 0, 0.58)',
    '0 56px 64px -26px rgba(0, 0, 0, 0.6)',
    '0 60px 68px -28px rgba(0, 0, 0, 0.62)',
    '0 64px 72px -30px rgba(0, 0, 0, 0.64)',
    '0 68px 76px -32px rgba(0, 0, 0, 0.66)',
    '0 72px 80px -34px rgba(0, 0, 0, 0.68)',
    '0 76px 84px -36px rgba(0, 0, 0, 0.7)',
    '0 80px 88px -38px rgba(0, 0, 0, 0.72)',
    '0 84px 92px -40px rgba(0, 0, 0, 0.74)',
    '0 88px 96px -42px rgba(0, 0, 0, 0.76)',
    '0 92px 100px -44px rgba(0, 0, 0, 0.78)',
    '0 96px 104px -46px rgba(0, 0, 0, 0.8)',
  ],
  light: [
    'none',
    '0 1px 2px 0 rgba(15, 23, 42, 0.05)',
    '0 1px 3px 0 rgba(15, 23, 42, 0.08), 0 1px 2px -1px rgba(15, 23, 42, 0.08)',
    '0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 2px 4px -2px rgba(15, 23, 42, 0.08)',
    '0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 4px 6px -4px rgba(15, 23, 42, 0.08)',
    '0 20px 25px -5px rgba(15, 23, 42, 0.1), 0 8px 10px -6px rgba(15, 23, 42, 0.1)',
    '0 24px 32px -10px rgba(15, 23, 42, 0.12)',
    '0 28px 36px -12px rgba(15, 23, 42, 0.14)',
    '0 32px 40px -14px rgba(15, 23, 42, 0.16)',
    '0 36px 44px -16px rgba(15, 23, 42, 0.18)',
    '0 40px 48px -18px rgba(15, 23, 42, 0.2)',
    '0 44px 52px -20px rgba(15, 23, 42, 0.22)',
    '0 48px 56px -22px rgba(15, 23, 42, 0.24)',
    '0 52px 60px -24px rgba(15, 23, 42, 0.26)',
    '0 56px 64px -26px rgba(15, 23, 42, 0.28)',
    '0 60px 68px -28px rgba(15, 23, 42, 0.3)',
    '0 64px 72px -30px rgba(15, 23, 42, 0.32)',
    '0 68px 76px -32px rgba(15, 23, 42, 0.34)',
    '0 72px 80px -34px rgba(15, 23, 42, 0.36)',
    '0 76px 84px -36px rgba(15, 23, 42, 0.38)',
    '0 80px 88px -38px rgba(15, 23, 42, 0.4)',
    '0 84px 92px -40px rgba(15, 23, 42, 0.42)',
    '0 88px 96px -42px rgba(15, 23, 42, 0.44)',
    '0 92px 100px -44px rgba(15, 23, 42, 0.46)',
    '0 96px 104px -46px rgba(15, 23, 42, 0.48)',
  ],
} satisfies Record<ColorScheme, Shadows>;
